// extracted by mini-css-extract-plugin
module.exports = {"grid":"student-grid_grid__3sHUC","minWidth":"student-grid_minWidth__1nDaL"};